import { render, staticRenderFns } from "./CopyRight.vue?vue&type=template&id=bb09b652&scoped=true"
import script from "./CopyRight.vue?vue&type=script&lang=js"
export * from "./CopyRight.vue?vue&type=script&lang=js"
import style0 from "./CopyRight.vue?vue&type=style&index=0&id=bb09b652&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb09b652",
  null
  
)

export default component.exports